module.exports = __webpack_public_path__ + "img/ambatya_yes.110d507f.png";